import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", { class: "mb-2" }, "Tagihan Belum Bayar", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("canvas", { id: "doughnutchart2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}